function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgHealthConcerns = function SvgHealthConcerns(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement(Path, {
    stroke: props.fillLine,
    strokeWidth: 1.2,
    d: "M12 9.6v3.6m0 0v3.6m0-3.6H8.4m3.6 0h3.6M9 7.8V5.4h6v2.4m-11.4 0h16.8v10.8H3.6z"
  }));
};
export default SvgHealthConcerns;